import classNames from 'classnames';
import {twMerge} from 'tailwind-merge';

export const cn = (...inputs: unknown[]) => {
  return twMerge(classNames(inputs));
};
